import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
    //   behavior: "smooth", // Smooth scroll effect
    });
  }, [pathname]); // Runs when the route changes

  return null;
};

export default ScrollToTop;
